import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { HeadingProps } from './types';

const alignmentClasses = {
  Left: 'text-left',
  Center: 'text-center',
  Right: 'text-right',
} as const;

const backgroundClasses = {
  White: 'bg-white',
  Gray: 'bg-tonal-bg',
  Blue: 'bg-global-brand-primary',
  Transparent: 'bg-transparent',
} as const;

const textColorClasses = {
  White: 'text-white',
  Primary: 'text-primary-500',
  Secondary: 'text-secondary-500',
} as const;

const headingSizeClasses = {
  H1: 'heading-1',
  H2: 'heading-2',
  H3: 'heading-3',
  H4: 'heading-4',
  H5: 'heading-5',
  H6: 'heading-6',
} as const;

const Heading = ({ data }: { data: HeadingProps }) => {
  const headingType = data.headingType || 'H2';
  const alignment = data.alignment || 'Left';
  const backgroundColor = data.backgroundColor || 'Transparent';
  const textColor = data.textColor || 'Primary';
  const className = data.className || '';
  const text = data.text;

  const HeadingTag = headingType.toLowerCase() as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

  const renderText = () => {
    if (typeof text === 'string') return text;
    return documentToReactComponents(text);
  };

  return (
    <div className={backgroundClasses[backgroundColor]}>
      <HeadingTag
        className={`heading-component text-inherit ${headingSizeClasses[headingType]} ${alignmentClasses[alignment]} ${className}`}
      >
        {renderText()}
      </HeadingTag>
    </div>
  );
};

export default Heading;
